<template>
  <v-container>
    <v-row>
      <p v-if="user" class="display-1">
        {{ user.firstName }} {{ user.lastName }}
      </p>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.getters.user;
    }
  }
};
</script>

<style lang="scss" scoped></style>
